import { Emitter, type Event } from '@patsnap/tahiti-core';

export interface ToolCompletedEvent {
    projectId: string;
    conversationId: string;
    toolCallId: string;
    toolName: string;
    success: boolean;
    timestamp: string;
}

export interface ToolEventSource {
    readonly onCompleted: Event<ToolCompletedEvent>;
}

export interface ToolEventPublisher {
    /** 发布工具调用完成事实。 */
    publishCompleted(event: ToolCompletedEvent): void;
}

/** 创建可隔离测试的工具领域事件服务。 */
export function createToolEvents(): ToolEventSource & ToolEventPublisher {
    const completedEmitter = new Emitter<ToolCompletedEvent>({
        onListenerError: error => console.error('[ToolEvents] listener failed:', error),
    });
    return {
        onCompleted: completedEmitter.event,
        publishCompleted: event => completedEmitter.fire(event),
    };
}

/** 应用级工具领域事件服务。 */
export const toolEvents = createToolEvents();
